<template>
    <div class="question">
        <h2 style="font-weight: 400; font-size: 32px;">Bereken je opbrengst</h2>
        <h2>Waar wil je zonnepanelen plaatsen?</h2>
        <span class="description">Maak een inschatting van het aantal beschikbare vierkante meters op de gekozen oppervlakte.</span>
        <div class="choice" v-bind:class="{ 'is--active': this.$store.state.variables.groundSurface > 0 }">
            <label class="choice-checkbox">
                <div class="icon">
                    <img src="https://zonnestroomnederland.nl/wp-content/themes/zonnestroomnl/src/img/calculator/ground.svg" height="66" />
                </div>
                <span class="title">Grond</span>
            </label>
            <div class="choice-range">
                <range-input-steps type="groundSurface" setter="setGroundSurface"></range-input-steps>
            </div>
        </div>
        <div class="choice" v-bind:class="{ 'is--active': this.$store.state.variables.flatRoofSurface > 0 }">
            <label class="choice-checkbox">
                <div class="icon">
                     <img src="https://zonnestroomnederland.nl/wp-content/themes/zonnestroomnl/src/img/calculator/flat_roof.svg" height="66" />
                </div>
                <span class="title">Plat dak</span>
            </label>
            <div class="choice-range">
                <range-input type="flatRoofSurface" setter="setFlatRoofSurface"></range-input>
            </div>
        </div>
        <div class="choice" v-bind:class="{ 'is--active': this.$store.state.variables.gableRoofSurface > 0 }">
            <label class="choice-checkbox" >
                <div class="icon">
                    <img src="https://zonnestroomnederland.nl/wp-content/themes/zonnestroomnl/src/img/calculator/gable_roof.svg" height="66" />
                </div>
                <span class="title">Zadeldak</span>
            </label>
            <div class="choice-range">
                <range-input type="gableRoofSurface" setter="setGableRoofSurface"></range-input>
            </div>
        </div>
        <div class="choice" v-bind:class="{ 'is--active': this.$store.state.variables.monoPitchedRoofSurface > 0 }">
            <label class="choice-checkbox" >
                <div class="icon">
                    <img src="https://zonnestroomnederland.nl/wp-content/themes/zonnestroomnl/src/img/calculator/mono_pitched_roof.svg" height="66" />
                </div>
                <span class="title">Hellend dak</span>
            </label>
            <div class="choice-range">
                <range-input type="monoPitchedRoofSurface" setter="setMonoPitchedRoofSurface"></range-input>
            </div>
        </div>
    </div>
</template>

<script>
import RangeInput from './helpers/range-input'
import RangeInputSteps from './helpers/range-input-steps'

export default {
  name: 'Q1',
  components: {
    'range-input': RangeInput,
    'range-input-steps': RangeInputSteps
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Q1.vue